var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyBidsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 17.4395C11.25 17.4395 12.0833 17.4395 12.9167 19.1062C12.9167 19.1062 15.5637 14.9395 17.9167 14.1062",
    stroke: "#757575",
    strokeWidth: 1.10833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 14.1062H9.16536M5.83203 9.93958H12.4987",
    stroke: "#757575",
    strokeWidth: 1.10833,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41553 3.6897C4.11903 3.72859 3.14854 3.67527 2.61368 4.21063C1.88144 4.94355 2.07894 6.32078 2.07894 8.68V14.1017C2.07894 16.4609 2.07894 17.8527 2.81117 18.5856C3.5434 19.3185 4.72192 19.1064 7.07894 19.1064H9.16228M12.909 3.6897C14.2055 3.72859 14.9785 3.8729 15.5134 4.40826C16.2456 5.14117 16.2456 6.32078 16.2456 8.68V12.023",
    stroke: "#757575",
    strokeWidth: 1.10833,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41406 3.89803C5.41406 3.09261 6.06699 2.4397 6.8724 2.4397H11.4557C12.2612 2.4397 12.9141 3.09261 12.9141 3.89803C12.9141 4.70345 12.2612 5.35636 11.4557 5.35636H6.8724C6.06699 5.35636 5.41406 4.70345 5.41406 3.89803Z",
    stroke: "#757575",
    strokeWidth: 1.10833,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBidsIcon);
export default __webpack_public_path__ + "static/media/my-bids-icon.5735e34737653ad7e1cda0f840f19d47.svg";
export { ForwardRef as ReactComponent };